<template>
    <app-modal-share
        :twitter-share="true"
        :share-url="shareURL"
        :content-title="content.title"
        :contentshortCode="projectShortCode"
        @close="$emit('close')"
    >
        <template #header-title>
            <div class="is-centered is-size-5 has-text-weight-bold">{{ $t('Share.share_title') }}</div>
        </template>

        <template #content>
            <div class="is-clipped">
                <label v-t="'Share.link'" class="label"></label>
                <div class="field has-addons shareUrl">
                    <p class="control is-expanded mb-0">
                        <input :value="shareURL" readonly class="input is-6" type="text" />
                    </p>
                    <p class="control">
                        <a
                            :class="{
                                'has-tooltip-active': showCopiedTooltipLink,
                            }"
                            :data-tooltip="
                                $t(
                                    showCopiedTooltipLink
                                        ? 'Sessions.url_copied'
                                        : 'Sessions.copy_url'
                                )
                            "
                            class="button is-disabled has-tooltip-left"
                            @click="copyURL"
                        >
                            <span class="icon is-small">
                                <i class="mdi mdi-18px mdi-content-copy"></i>
                            </span>
                        </a>
                    </p>
                </div>

                <label v-t="'Share.iframe'" class="label"></label>
                <div class="field has-addons shareIframe">
                    <div class="control is-expanded mb-0">
                        <textarea :value="shareIframe" readonly rows="4" class="input"></textarea>
                    </div>
                    <div class="control">
                        <a
                            :class="{
                                'has-tooltip-active': showCopiedTooltipIframe,
                            }"
                            :data-tooltip="
                                $t(
                                    showCopiedTooltipIframe
                                        ? 'Sessions.url_copied'
                                        : 'Sessions.copy_url'
                                )
                            "
                            class="button is-disabled has-tooltip-left"
                            @click="copyIframe"
                        >
                            <span class="icon is-small">
                                <i class="mdi mdi-18px mdi-content-copy"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </template>
        <template #footer-right-button></template>
    </app-modal-share>
</template>

<script>
import AppModalShare from '@/components/AppModalShare';
export default {
    components: {
        AppModalShare,
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            showCopiedTooltipLink: false,
            showCopiedTooltipIframe: false,
        };
    },
    computed: {
        shareURL() {
            let url = process.env.VUE_APP_SHARE_ROOT_URL;
            if (this.content.project != undefined) {
                url += this.content.project + '/';
            }
            return url + this.content._id;
        },
        shareEmbedURL() {
            let url = process.env.VUE_APP_SHARE_EMBED_ROOT_URL;
            if (this.content.project != undefined) {
                url += this.content.project + '/';
            }
            return url + this.content._id;
        },
        shareIframe() {
            return (
                '<iframe width="100%" height="900px" src="' +
                this.shareEmbedURL +
                '"></iframe>'
            );
        },
        projectShortCode() {
            if(this.content.type!='trivial'){
                return this.content.shortCode
            }
        }
    },
    methods: {
        copyURL() {
            this.$copyText(this.shareURL).then((e) => {
                this.showCopiedTooltipLink = true;
                setTimeout(() => {
                    this.showCopiedTooltipLink = false;
                }, 1500);
            });
        },
        copyIframe() {
            this.$copyText(this.shareIframe).then((e) => {
                this.showCopiedTooltipIframe = true;
                setTimeout(() => {
                    this.showCopiedTooltipIframe = false;
                }, 1500);
            });
        },
    },
};
</script>

<style scoped>
.shareUrl input,
.shareUrl a {
    height: 3rem;
}
.shareIframe textarea,
.shareIframe a {
    height: 7.5rem;
}
.is-centered {
    margin: 0 auto;
}
</style>
